"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var colors_1 = require("../colors");
var styled_1 = require("./styled");
var Separator = function (_a) {
    var color = _a.color, thickness = _a.thickness, spacing = _a.spacing, variant = _a.variant, props = tslib_1.__rest(_a, ["color", "thickness", "spacing", "variant"]);
    return (react_1.default.createElement(styled_1.StyledSeparator, tslib_1.__assign({ color: color, thickness: thickness, spacing: spacing, variant: variant }, props)));
};
Separator.defaultProps = {
    color: colors_1.gray[0],
    thickness: '1px',
    variant: 'horizontal',
    spacing: '16px',
};
exports.default = Separator;
//# sourceMappingURL=index.js.map